import { gql } from "@apollo/client";

export const NORTHBEAM_INDEX = gql`
  query GetNorthbeamIndex(
    $accountingMode: String!
    $attributionModel: String!
    $attributionWindow: String!
    $dateRange: SalesDateRangeInput!
    $indexType: String!
    $metric: String!
  ) {
    me {
      northbeamIndex(
        accountingMode: $accountingMode
        attributionModel: $attributionModel
        attributionWindow: $attributionWindow
        dateRange: $dateRange
        indexType: $indexType
        metric: $metric
      ) {
        rows {
          date
          value
        }
        queryMetadata {
          bqLogs {
            query
            queryParameters
            queryTypes
            labels
            jobId
            queryId
            executionTimestamp
          }
        }
      }
    }
  }
`;
